module.exports = __webpack_public_path__ + "static/media/banner-pharmacy.fcda8737.png";